import React from 'react'

import {
    RiAddLine,
    RiArchive2Line,
    RiArrowDownSLine,
    RiArrowLeftLine,
    RiArrowLeftRightFill,
    RiArrowLeftRightLine,
    RiArrowRightLine,
    RiCalendarLine,
    RiCheckboxBlankLine,
    RiCheckboxFill,
    RiCloseCircleLine,
    RiCloseLine,
    RiDeleteBinLine,
    RiExpandUpDownLine,
    RiEyeLine,
    RiEyeOffLine,
    RiFileDownloadLine,
    RiHomeGearFill,
    RiHomeGearLine,
    RiInstallLine,
    RiLogoutCircleRLine,
    RiMailLine,
    RiMapPinLine,
    RiMenuFill,
    RiPhoneLine,
    RiRouteLine,
    RiSearchLine,
    RiSettings2Line,
    RiShoppingBagLine,
    RiSwapBoxFill,
    RiToolsFill,
    RiToolsLine,
    RiUserAddFill,
    RiUserLine,
    RiUserSettingsFill,
    RiUserUnfollowFill,
    RiTimeLine,
    RiCheckLine,
} from "react-icons/ri";
import { GetIconColor } from '../theme/main_style'
import { FaCcAmex, FaCcDinersClub, FaCcDiscover, FaCcJcb } from 'react-icons/fa'

export const iconFontSize = {
    xxxs: 16,
    xxs: 20,
    xs: 24,
    sm: 28,
    md: 32,
    lg: 36,
    xl: 40,
    xxl: 48,
    xxxl: 56
}
export const ArrowLeftIcon = (props) => { return <RiArrowLeftLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const ArrowRightIcon = (props) => { return <RiArrowRightLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const ArrowDownIcon = (props) => { return <RiArrowDownSLine color={props.color ? props.color : GetIconColor().primary} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CloseIcon = (props) => { return <RiCloseCircleLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const SortIcon = (props) => { return <RiExpandUpDownLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }

export const EyeOffIcon = (props) => { return <RiEyeOffLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const EyeIcon = (props) => { return <RiEyeLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }

export const MenuIcon = (props) => { return <RiMenuFill color={props.color ? props.color : GetIconColor().black} size={props.size} /> }
export const InstallationIcon = (props) => { return <RiUserSettingsFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }
export const RemoveDeviceIcon = (props) => { return <RiUserUnfollowFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }
export const SwapDeviceIcon = (props) => { return <RiSwapBoxFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }
export const AddDeviceIcon = (props) => { return <RiUserAddFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }
export const ReInstallIcon = (props) => { return <RiToolsFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }
export const ServiceVisitIcon = (props) => { return <RiHomeGearFill color={props.color ? props.color : GetIconColor().primary} size={props.size} /> }

export const LogoutIcon = (props) => { return <RiLogoutCircleRLine color={props.color ? props.color : GetIconColor().primary} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CloseLineIcon = (props) => { return <RiCloseLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }

export const UserIcon = (props) => { return <RiUserLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const EmailIcon = (props) => { return <RiMailLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const PhoneIcon = (props) => { return <RiPhoneLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CalendarIcon = (props) => { return <RiCalendarLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CheckedBoxIcon = (props) => { return <RiCheckboxFill color={props.color ? props.color : GetIconColor().primary} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CheckBoxIcon = (props) => { return <RiCheckboxBlankLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }

export const ShoppingBagIcon = (props) => { return <RiShoppingBagLine color={props.color ? props.color : GetIconColor().white} size={props.size ? props.size : iconFontSize.xs} /> }
export const DeviceIcon = (props) => { return <RiRouteLine color={props.color ? props.color : GetIconColor().white} size={props.size ? props.size : iconFontSize.xs} /> }
export const EnableDeviceIcon = (props) => { return <RiSettings2Line color={props.color ? props.color : GetIconColor().white} size={props.size ? props.size : iconFontSize.xs} /> }
export const CompletedIcon = (props) => { return <RiInstallLine color={props.color ? props.color : GetIconColor().white} size={props.size ? props.size : iconFontSize.xs} /> }
export const ItemIcon = (props) => { return <RiArchive2Line color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const SearchIcon = (props) => { return <RiSearchLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const LocationIcon = (props) => { return <RiMapPinLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const PlusIcon = (props) => { return <RiAddLine color={props.color ? props.color : GetIconColor().primary} size={props.size ? props.size : iconFontSize.xs} /> }
export const FileDownloadIcon = (props) => { return <RiFileDownloadLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.lg} /> }
export const DeleteIcon = (props) => { return <RiDeleteBinLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xs} /> }
export const ClockIcon = (props) => { return <RiTimeLine color={props.color ? props.color : GetIconColor().default} size={props.size ? props.size : iconFontSize.xxs} /> }
export const CheckIcon = (props) => { return <RiCheckLine color={props.color ? props.color : GetIconColor().primary} size={props.size ? props.size : iconFontSize.xs} /> }
